import { App } from '../../pkg';
import FPS from './fps';

interface Looper {
  fps: FPS;
  start: () => void;
  requestRender: () => void;
}

export const makeLooper = (app: App): Looper => {
  const fps = new FPS();
  let dirty = true;
  const loop = () => {
    if (dirty) {
      fps.render();
      app.render();
      dirty = false;
    }
    window.requestAnimationFrame(loop);
  };
  const looper = {
    fps,
    start: function () {
      window.requestAnimationFrame(loop);
    },
    requestRender: function () {
      dirty = true;
    },
  };
  return looper;
};
